module.exports = __webpack_public_path__ + "static/media/Distinction Bias - robert-anasch-ZFYg5jTvB4A-unsplash.06f2e843.jpg";